var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 0h-400v300h400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m439.996 300h-399.996v179.996h399.996z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6133-22.387-50-50-50h-300c-27.6133 0-50 22.3867-50 50v380c0 27.613 22.3867 50 50 50h239.996l110.004-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0547-17.945-40-40-40h-300c-22.0547 0-40 17.9453-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.926l107.074-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#68ab46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.996 480h-239.996c-27.6133 0-50-22.387-50-50v-380c0-27.6133 22.3867-50 50-50h300c27.613 0 50 22.3867 50 50v320zm-4.141-10 104.145-104.141v-315.859c0-22.0547-17.945-40-40-40h-300c-22.0547 0-40 17.9453-40 40v380c0 22.055 17.9453 40 40 40z",
    fill: "#5c973e"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.352 384.973 96.793-96.793v96.793z",
    fill: "#5c973e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.613 0-50 22.387-50 50v60h110z",
    fill: "#b3d5a2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m220 120v30h130v-30zm-90 30h70v-30h-70zm70 60v-30h-70v30zm150 0v-30h-130v30zm-250 30v-150h280v150z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m93.5156 417.699h13.2184l11.586-17.644 11.993 17.644h12.863l-18.266-27.426 20.067-30.273h-12.848l-13.723 20.508-13.656-20.508h-13.125l20.273 30.234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.238 417.699h12.348v-45.261h17.008v-12.438h-29.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.77 412.473-7.735-8.485c-4.07 2.403-7.004 3.606-8.789 3.606-1.379 0-2.562-.524-3.558-1.559-.997-1.039-1.497-2.281-1.497-3.715 0-2.843 2.579-5.304 7.735-7.382 3.781-1.614 6.637-3.075 8.57-4.372 1.934-1.308 3.551-3.113 4.856-5.429 1.3-2.313 1.957-4.821 1.957-7.516 0-4.949-1.996-9.258-6-12.918-3.996-3.664-8.723-5.492-14.172-5.492-5.977 0-11.879 2.809-17.711 8.434l8.176 9.539c3.66-3.782 7.089-5.668 10.281-5.668 1.496 0 2.93.664 4.308 1.992 1.375 1.332 2.067 2.726 2.067 4.187 0 3.008-3.18 5.664-9.539 7.961-3.633 1.321-6.211 2.563-7.735 3.719-1.523 1.156-2.804 2.844-3.839 5.059-1.047 2.207-1.567 4.472-1.567 6.789 0 5.125 1.672 9.285 5.012 12.48 3.34 3.192 7.707 4.789 13.098 4.789 6.382 0 11.746-2.008 16.082-6.019"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.3ddf23207e23d3e1934292162e00a9a3.svg";
export { ForwardRef as ReactComponent };